import React, {useEffect} from 'react'
import {FormProvider, useForm} from "react-hook-form";
import RenderedHtmlContent from "../../../../shared/virtual_congress/components/rendered_html_content";
import FormFields from "./form_fields";
import EventGroups from "./event_groups";
import Dsgvo from "./dsgvo";
import Rfid from "./rfid";
import Footer from "./footer";
import Sidebar from "./sidebar";
import {useSelector} from "react-redux";
import CompanionContent from "./companion_content";
import DeclineRadioButtonContent from "./decline_radio_button_content";
import FormButtons from "./form_buttons";
import {useOnSubmit} from "../utils";

const Form = () => {
  const methods = useForm({shouldUnregister: true});
  const {handleSubmit,
    register,
    formState: { errors },
    setError,
    clearErrors,
    formState ,
    setValue,
    getValues
  } = methods;

  const declineMode = useSelector(state => state.decline_mode) || "disabled"
  const isRadioButtonDeclineMode = ["with_radio_button", "with_radio_button_with_form", "with_radio_button_without_form"].includes(declineMode)
  const showForm = useSelector(state => state.registrationPageState?.showForm) || declineMode !== "with_radio_button_without_form"

  const tagOwner = useSelector(state => state.tagOwner)

  const headerHeadline = useSelector(state => state.headerHeadLine).trim() // Full width
  const headerText = useSelector(state => state.headerText).trim() // Form width and shared between registration and prefilled
  const formHeaderText = useSelector(state => state.formHeaderText).trim() // Not shared.

  const companionConfig = useSelector(state => state.companion)

  const onSubmit = useOnSubmit(setError)

  const { dirtyFields } = formState;

  useEffect(() => {
    window.setFormValue = (name, value) => {
      setValue(name, value)
    }
    window.getFormValues = () => {
      return getValues()
    }
  }, [setValue, getValues]);
  

  return (
    <FormProvider {...methods} >
      <div className="r-container row">
        <div className="col">
          <div className="row">
            <div className="r-header col-sm-12">
              <RenderedHtmlContent html={headerHeadline}/>
            </div>
          </div>
          <div className="r-inner-container row">
            <div className="col">
              {headerText && <div className="r-header-text">
                <RenderedHtmlContent html={headerText}/>
              </div>}
              {formHeaderText && <div className="r-form-header-text">
                <RenderedHtmlContent html={formHeaderText}/>
              </div>}
              <div className="row">
                <form className="r-form col-md-12" onSubmit={handleSubmit(onSubmit)}>
                  {isRadioButtonDeclineMode && <DeclineRadioButtonContent/>}
                  {showForm && <>
                    <FormFields tagOwner={tagOwner} fieldType={"tag_owner"} register={register} errors={errors}/>
                    {/* This is just to move it below the companion content if set to false.*/}
                    {companionConfig.show_event_selection &&
                    <EventGroups fieldType={"tag_owner"}/>}

                    <CompanionContent/>

                    {/* This is just to move it below the companion content if set to false.*/}
                    {!companionConfig.show_event_selection &&
                    <EventGroups fieldType={"tag_owner"}/>}

                    <Dsgvo />
                    <Rfid />
                  </>}
                  <FormButtons/>
                </form>
              </div>
              <Footer/>
            </div>
            <Sidebar/>
          </div>
        </div>
      </div>
    </FormProvider>
  );
}

export default Form
